import { render, staticRenderFns } from "./DPMProcessingDetail.vue?vue&type=template&id=4838e440&scoped=true"
import script from "./DPMProcessingDetail.vue?vue&type=script&lang=js"
export * from "./DPMProcessingDetail.vue?vue&type=script&lang=js"
import style0 from "./DPMProcessingDetail.vue?vue&type=style&index=0&id=4838e440&prod&scoped=true&lang=css"
import style1 from "./DPMProcessingDetail.vue?vue&type=style&index=1&id=4838e440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838e440",
  null
  
)

export default component.exports